var newsHeadingInit = function () {

	$('#latest-news-label').detach().prependTo(".m-news-item:first-of-type .m-news-article .m-news-title");
};



